/* The Andes Austrix · Contact form: accessible "Motivo" listbox + extra fields per reason.
   Progressive enhancement: without JS the native <select> works and extras stay hidden/disabled. */
(() => {
  const init = (wrap) => {
    if (wrap.dataset.aaCtReady) return;
    wrap.dataset.aaCtReady = '1';
    const form = wrap.closest('form');
    const select = wrap.querySelector('select');
    const btn = wrap.querySelector('.aa-select__btn');
    const list = wrap.querySelector('[role="listbox"]');
    const val = wrap.querySelector('[data-aa-ct-val]');
    const err = document.getElementById(select.id + '-err');
    const label = document.getElementById(select.id + '-label');
    const opts = [...list.querySelectorAll('[role="option"]')];
    const extras = [...form.querySelectorAll('.aa-ct-extra')];
    const body = form.querySelector('[data-aa-ct-body]');
    let active = -1;
    let typed = '';
    let typedTimer;

    // Enhance: hide native select (kept for submission), show button + listbox
    wrap.classList.add('is-enhanced');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    select.required = false;
    btn.hidden = false;
    label.setAttribute('for', btn.id);

    const toggleBlock = (el, on) => {
      el.hidden = !on;
      el.disabled = !on;
    };

    const syncSub = (extra) => {
      extra.querySelectorAll('[data-show-when]').forEach((sub) => {
        const picked = extra.querySelector('.aa-chips input:checked');
        toggleBlock(sub, !extra.disabled && picked?.value === sub.dataset.showWhen);
      });
    };

    const apply = (animate) => {
      const opt = select.selectedOptions[0];
      const key = opt?.dataset.key || '';
      extras.forEach((ex) => {
        const on = ex.dataset.motivo === key;
        toggleBlock(ex, on);
        if (on && animate) { ex.classList.remove('is-shown'); void ex.offsetWidth; ex.classList.add('is-shown'); }
        syncSub(ex);
      });
      if (body && opt?.dataset.ph) body.placeholder = opt.dataset.ph;
      opts.forEach((o) => o.setAttribute('aria-selected', String(o.dataset.value === select.value)));
      val.textContent = select.value || select.options[0].text;
      wrap.classList.toggle('has-value', !!select.value);
    };

    const setActive = (i) => {
      active = Math.max(0, Math.min(opts.length - 1, i));
      opts.forEach((o, n) => o.classList.toggle('is-active', n === active));
      list.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    };

    const open = () => {
      if (!list.hidden) return;
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      const cur = opts.findIndex((o) => o.dataset.value === select.value);
      setActive(cur >= 0 ? cur : 0);
      list.focus({ preventScroll: true });
    };

    const close = (refocus = true) => {
      if (list.hidden) return;
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
      list.removeAttribute('aria-activedescendant');
      if (refocus) btn.focus({ preventScroll: true });
    };

    const choose = (i) => {
      const changed = select.value !== opts[i].dataset.value;
      select.value = opts[i].dataset.value;
      if (err) err.hidden = true;
      btn.removeAttribute('aria-invalid');
      apply(changed);
      if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
      close();
    };

    btn.addEventListener('click', () => (list.hidden ? open() : close()));
    btn.addEventListener('keydown', (e) => {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) { e.preventDefault(); open(); }
    });

    list.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); setActive(active + 1); break;
        case 'ArrowUp': e.preventDefault(); setActive(active - 1); break;
        case 'Home': e.preventDefault(); setActive(0); break;
        case 'End': e.preventDefault(); setActive(opts.length - 1); break;
        case 'Enter': case ' ': e.preventDefault(); choose(active); break;
        case 'Escape': e.preventDefault(); close(); break;
        case 'Tab': choose(active); break;
        default:
          if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
            clearTimeout(typedTimer);
            typed += e.key.toLowerCase();
            typedTimer = setTimeout(() => { typed = ''; }, 600);
            const norm = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
            const i = opts.findIndex((o) => norm(o.dataset.value).startsWith(norm(typed)));
            if (i >= 0) setActive(i);
          }
      }
    });

    opts.forEach((o, i) => {
      o.addEventListener('click', () => choose(i));
      o.addEventListener('pointermove', () => { if (active !== i) setActive(i); });
    });

    document.addEventListener('pointerdown', (e) => { if (!wrap.contains(e.target)) close(false); });
    list.addEventListener('focusout', (e) => { if (!wrap.contains(e.relatedTarget)) close(false); });

    // Sub-blocks (e.g. invoice data) follow the chip picked inside each extra block
    form.addEventListener('change', (e) => {
      const ex = e.target.closest('.aa-ct-extra');
      if (ex && e.target.type === 'radio') syncSub(ex);
    });

    // Reason is required: the native select is hidden, so validate it here
    form.addEventListener('submit', (e) => {
      if (select.value) return;
      e.preventDefault();
      if (err) err.hidden = false;
      btn.setAttribute('aria-invalid', 'true');
      btn.setAttribute('aria-describedby', err?.id || '');
      btn.focus();
    });

    // Links from the emails can preselect the reason and the order: ?motivo=problema&pedido=AX-1001005
    const qs = new URLSearchParams(location.search);
    const want = qs.get('motivo');
    if (want && !select.value) {
      const o = [...select.options].find((x) => x.dataset.key === want);
      if (o) select.value = o.value;
    }
    apply(false);
    const ped = (qs.get('pedido') || '').slice(0, 20);
    if (ped) {
      const inp = extras.find((ex) => ex.dataset.motivo === want)?.querySelector('input[name="contact[Número de pedido]"]');
      if (inp && !inp.value) inp.value = ped;
    }
  };

  const run = () => document.querySelectorAll('[data-aa-ct-select]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
